// formReducer.js
const initialState = {
    token:'',
    refreshToken: '',
    tokenExpiresIn: '',
    refreshTokenExpiresIn: '',
    transactionId:'',
    traceId:'',
    status: '',
    reuse: 1,
};

const TokenReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_TOKEN':
            return {
                ...state,
                token: action.payload.token,
                refreshToken: action.payload.refreshToken,
                tokenExpiresIn: action.payload.tokenExpiresIn,
                refreshTokenExpiresIn: action.payload.refreshTokenExpiresIn,
                transactionId: action.payload.transactionId,
                status: action.payload.status,
                traceId: action.payload.traceId,
            };
        case 'SET_TRANSACTION_INITIAL_DATA':
            return {
                ...state,
                transactionId: action.payload.transactionId,
                status: action.payload.status,
                traceId: action.payload.traceId,
            };

        case 'SET_STATUS' :
            return{
                ...state,
                status: action.payload.status,
            };

        case 'SET_TRANSACTION' :
            return{
                ...state,
                transactionId: action.payload.transactionId,
            };
        case 'SET_REUSE' :
            return{
                ...state,
                reuse: action.payload.reuse,
            };
        case 'RESET' :
            return initialState;
        case 'RESET_CERTIFICATE_FLOW' :
            return initialState;
        default:
            return state;
    }
};

export default TokenReducer;
  